import { useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import { DOCUMENTS_QUERY } from "./useDocuments";

const UPDATE_DOCUMENT_MUTATION = gql`
  mutation UpdateDocument(
    $id: ID!
    $title: String
    $description: String
    $documentType: DocumentTypeEnum
    $visibility: DocumentVisibilityEnum
  ) {
    updateDocument(
      id: $id
      title: $title
      description: $description
      documentType: $documentType
      visibility: $visibility
    ) {
      document {
        id
        title
        description
        documentType
        visibility
      }
    }
  }
`;

export interface UpdateDocumentInput {
  id: string;
  title?: string | null;
  description?: string | null;
  documentType?: string | null;
  visibility?: string | null;
}

export function useUpdateDocument(projectId: string) {
  const [updateMutation, { loading, error }] = useMutation(
    UPDATE_DOCUMENT_MUTATION,
    {
      refetchQueries: [{ query: DOCUMENTS_QUERY, variables: { projectId } }],
    }
  );

  const updateDocument = async (input: UpdateDocumentInput) => {
    const documentType =
      input.documentType != null
        ? (input.documentType.toUpperCase() as "IMAGE" | "DOCUMENT" | "PROJECT")
        : undefined;
    const visibility =
      input.visibility != null
        ? (input.visibility.toUpperCase() as "INTERNAL" | "SHARED")
        : undefined;
    const { data } = await updateMutation({
      variables: {
        id: input.id,
        title: input.title ?? undefined,
        description: input.description ?? undefined,
        documentType,
        visibility,
      },
    });
    return (data as { updateDocument: { document: { id: string } } })
      .updateDocument.document;
  };

  return { updateDocument, loading, error };
}
